<div id="billing"></div>
<button class="close" color="primary" mat-mini-fab (click)="closeDialog()">
  <mat-icon>close</mat-icon>
</button>
